import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { IconComponent } from '../../../components/icon/icon.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { FooterEndComponent } from './footer-end.component';
import { FooterStartComponent } from './footer-start.component';

@Component({
  selector: 'td-wb-menu-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss'],
  imports: [
    FooterEndComponent,
    IconButtonComponent,
    HrefDirective,
    TranslatePipe,
    IconComponent,
    FooterStartComponent,
    TranslateDirective
  ]
})
export class FooterComponent {
  readonly isHidden = input<boolean>(false);
}
